module.exports = __webpack_public_path__ + "assets/img/submissions-background-cover.0e610c87.png";